import React, { FunctionComponent } from 'react'
import translate from 'core/translate'
import { IFilterButtonProps } from './FilterButton-types'
import { Button } from 'molecules/Button'
import { palette } from '../../theme'

export const FilterButton: FunctionComponent<IFilterButtonProps> = ({ active = false, disabled, onClick }) => (
    <Button
        aria-expanded={active}
        onClick={onClick}
        icon={{
            type: 'new_filter_icon',
            position: 'left',
            color: palette.white.main,
            size: 18,
        }}
        mod={'fillBrand'}
    >
        {translate('filter')}
    </Button>
)
